module.exports = __webpack_public_path__ + "img/start2.00b704fc.svg";